import { FaPalette, FaGraduationCap, FaAward, FaBrush } from 'react-icons/fa';
import { FiInstagram, FiFacebook } from 'react-icons/fi';
import portrait from './assets/2.jpg';
import artwork1 from './assets/3.jpg';
import artwork2 from './assets/vint1.jpg';
import donziaw1 from './assets/donzi_aw_1.jpg';
import donziaw2 from './assets/donzi_aw_2.jpg';
import donziaw3 from './assets/donzi_aw_3.jpg';
import donziaw4 from './assets/donzi_aw_4.jpg';
import donziaw5 from './assets/donzi_aw_5.jpg';
import donzi from './assets/Donzi.jpg';
import Navbar from './Navbar';
import Footer from './Footer';

const AboutDonzi = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 font-sans">
        <Navbar />
      {/* Hero Section */}
      <section className="relative py-32 px-4 bg-gradient-to-r from-[#00B7F1]/10 to-[#C3D83B]/10">
        <div className="container mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl font-light mb-6 tracking-wide">
            <span className="font-normal" style={{ color: '#00B7F1' }}>DONZI EL HUSSEINY</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-light tracking-wide">
            Artist, Educator, and Founder of Donzi Art Academy
          </p>
        </div>
      </section>

      {/* Bio Section */}
      <section className="py-16 px-4 sm:py-24 bg-white">
        <div className="container mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="lg:w-1/3">
              <div className="relative">
                <div className="absolute -inset-4 border-2 border-[#C3D83B] rounded-lg transform rotate-2 z-0"></div>
                <img 
                  src={donzi} 
                  alt="Donzi El Husseiny" 
                  className="w-full h-auto object-cover rounded-lg relative z-10 shadow-lg"
                />
              </div>
            </div>
            <div className="lg:w-2/3">
              <h2 className="text-3xl sm:text-4xl font-light mb-6 tracking-wide">
                About <span className="font-normal" style={{ color: '#00B7F1' }}>Donzi</span>
              </h2>
              <p className="text-gray-600 mb-6 font-light tracking-wide text-lg">
                Donzi El Housseiny is an accomplished artist and art educator with a profound dedication to nurturing creativity in children. She is the founder and executive director of Donzi Art Academy, an institution she established over ten years ago to pursue her passion for teaching art to young learners.
                A graduate of the Faculty of Fine Arts, Donzi further enhanced her academic credentials by earning a Master’s degree from the University of Cambridge, specializing in art education for children. Her approach to art instruction is grounded in a belief that early artistic engagement cultivates not only creativity but also confidence, emotional intelligence, and a lifelong appreciation for the arts.
                Under her visionary leadership, Donzi Art Academy has grown into a leading center for junior art education. She has spearheaded numerous initiatives, including annual exhibitions in collaboration with both local and international artists. Notably, she led a group of young artists to represent Egypt at the first International Children’s Art Symposium in Rome in 2019.

              </p>
              <div className="flex space-x-4">
                <div 
                  className="text-gray-700 hover:text-[#00B7F1] transition cursor-pointer"
                  onClick={() => window.open('https://www.instagram.com/donzi_art.academy/', '_blank')}
                >
                  <FiInstagram className="w-6 h-6" />
                </div>
                <div 
                  className="text-gray-700 hover:text-[#00B7F1] transition cursor-pointer"
                  onClick={() => window.open('https://www.facebook.com/donziartacademy/', '_blank')}
                >
                  <FiFacebook className="w-6 h-6" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Achievements Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="container mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="lg:w-1/2">
              <h2 className="text-3xl sm:text-4xl font-light mb-6 tracking-wide">
                CAREER & EDUCATION <span className="font-normal" style={{ color: '#C3D83B' }}>HIGHLIGHTS</span>
              </h2>
              <div className="space-y-8">
                {[
                  {
                    year: "2019",
                    title: "Global Recognition",
                    description: "Pioneered the region's first International Art Exhibition for Children in Italy "
                  },
                  {
                    year: "2011",
                    title: "Founded Donzi Art Academy",
                    description: "Established with the mission to provide structured art education in Egypt"
                  },
                  {
                    year: "2009",
                    title: "Masters Degree from Cambridge",
                    description: "Specialized in Art Eduction for children"
                  },
                  {
                    year: "2005",
                    title: "Bachelor's Degree in Fine Arts ",
                    description: "Mural Painting Department, Faculty of Fine Arts"
                  }
                ].map((item, index) => (
                  <div key={index} className="flex gap-6">
                    <div className="flex-shrink-0">
                      <div className="w-16 h-16 rounded-full bg-[#00B7F1] text-white flex items-center justify-center text-xl font-light">
                        {item.year}
                      </div>
                    </div>
                    <div>
                      <h3 className="text-xl font-light tracking-wide mb-1" style={{ color: '#00B7F1' }}>{item.title}</h3>
                      <p className="text-gray-600 font-light tracking-wide">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
           
          </div>
        </div>
      </section>

      
      {/* Artwork Section */}
      <section className="py-16 px-4 sm:py-24 bg-white">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-light mb-4 tracking-wide">SELECTED <span className="font-normal" style={{ color: '#00B7F1' }}>ARTWORKS</span></h2>
            <p className="text-gray-600 max-w-2xl mx-auto font-light tracking-wide text-lg">
              A glimpse into Donzi's artistic practice
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="relative group">
              <img 
                src={donziaw1} 
                alt="Donzi El Husseiny artwork" 
                className="w-full h-auto object-cover rounded-lg shadow-lg"
              /></div>
              <div className="relative group"><img 
                src={donziaw2} 
                alt="Donzi El Husseiny artwork" 
                className="w-full h-auto object-cover rounded-lg shadow-lg"
              /></div>
              <div className="relative group"><img 
                src={donziaw5} 
                alt="Donzi El Husseiny artwork" 
                className="w-full h-auto object-cover rounded-lg shadow-lg"
              /></div>
              <div className="relative group"><img 
                src={donziaw4} 
                alt="Donzi El Husseiny artwork" 
                className="w-full h-auto object-cover rounded-lg shadow-lg"
              /></div>
              <div className="relative group"><img 
                src={donziaw3} 
                alt="Donzi El Husseiny artwork" 
                className="w-full h-auto object-cover rounded-lg shadow-lg"
              /></div>
          </div>
        </div>
      </section>


      {/* Teaching Philosophy Section */}
      <section className="py-16 px-4 sm:py-24 bg-white">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-light mb-4 tracking-wide">TEACHING <span className="font-normal" style={{ color: '#00B7F1' }}>PHILOSOPHY</span></h2>
          </div>
          
          <div className="space-y-8">
            <div className="p-8 border-l-4 border-[#C3D83B] bg-[#00B7F1]/5 rounded-r-lg">
              <p className="text-gray-700 italic font-light tracking-wide text-lg">
                "True artistic skill comes from mastering the fundamentals while developing one's unique perspective. 
                At Donzi Art Academy, we balance technical rigor with creative freedom."
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-8">
              {[
                {
                  title: "Structured Progression",
                  description: "Carefully designed curriculum that builds skills sequentially"
                },
                {
                  title: "Individual Attention",
                  description: "Small class sizes ensure personalized feedback"
                },
                {
                  title: "Professional Standards",
                  description: "Teaching students to work with discipline and professionalism"
                },
                {
                  title: "Cultural Context",
                  description: "Connecting technical skills to Egypt's rich artistic heritage"
                }
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-8 h-8 rounded-full bg-[#00B7F1] text-white flex items-center justify-center text-sm font-light mt-0.5 flex-shrink-0">
                    {index + 1}
                  </div>
                  <div>
                    <h3 className="text-lg font-light tracking-wide mb-1" style={{ color: '#C3D83B' }}>{item.title}</h3>
                    <p className="text-gray-600 font-light tracking-wide text-sm">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default AboutDonzi;